import { render, staticRenderFns } from "./RaioXProduto.vue?vue&type=template&id=111675b6&scoped=true"
import script from "./RaioXProduto.vue?vue&type=script&lang=js"
export * from "./RaioXProduto.vue?vue&type=script&lang=js"
import style0 from "./RaioXProduto.vue?vue&type=style&index=0&id=111675b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111675b6",
  null
  
)

export default component.exports